import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import IconBase from '../IconBase';
var Svg14X14ArrowLeftOutline = function Svg14X14ArrowLeftOutline(props) {
  return /*#__PURE__*/React.createElement(IconBase, _extends({
    viewBox: "0 0 14 14"
  }, props, {
    width: "14",
    height: "14"
  }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m4.575 5.955 1.158-1.171a1.054 1.054 0 0 0 0-1.478 1.024 1.024 0 0 0-1.46 0L.623 7l3.65 3.694a1.024 1.024 0 0 0 1.46 0 1.054 1.054 0 0 0 0-1.478L4.575 8.045h7.015c.57 0 1.033-.468 1.033-1.045s-.463-1.045-1.033-1.045z",
    clipRule: "evenodd"
  })));
};
export default Svg14X14ArrowLeftOutline;